import { REPORT_PERMISSION } from 'modules/campaigns/config/reportPermissions';
import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { MODULE_NAME as PUSH_API } from 'modules/push-api/config/routes';
import { columnDefinitions } from './columnDefinitions';
import { PUSH_API_REPORT_ID } from './pushApiReportId';
import { defaultColumns, customColumns } from './reportPresets';

export const pushApiReportConfig = {
    id: PUSH_API_REPORT_ID,
    label: 'API Integrations',
    module: PUSH_API,
    permissions: REPORT_PERMISSION.PUSH_API_VIEW,
    endpoint: 'push-api-subscriptions-report',
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    disableForceFetch: true,
    disableExport: false,
    searchPlaceholderMsgId: 'app.reports.push-api.search.placeholder',
    searchField: FIELDS.PUSH_API_SUB_NAME.field,
};
